var app = angular.module('camara', [
    'ngAnimate',
    'ngSanitize',
    'textAngular',
    'ui.router',
    'mgcrea.ngStrap',
    'uz.mailto',
    'pascalprecht.translate',
    'as.sortable',
    'angularBootstrapNavTree',
    'avalanche.legis'
]);

app.config(function($urlRouterProvider,$locationProvider,$translateProvider,$httpProvider,$provide,avalancheConfig) {
    $urlRouterProvider.deferIntercept();

    $locationProvider.html5Mode(false);

    $translateProvider.useLoader('$translatePartialLoader', {
	urlTemplate: avalancheConfig.backendAddress+'/labels/{lang}/{part}'
    });

    $translateProvider.preferredLanguage('pt_BR');
    $translateProvider.useSanitizeValueStrategy('escaped');

    $provide.decorator('taTools', ['$delegate', function(taTools){
        taTools.bold.iconclass = 'mdi mdi-format-bold';
        taTools.italics.iconclass = 'mdi mdi-format-italic';
        taTools.underline.iconclass = 'mdi mdi-format-underline';
        taTools.undo.iconclass = 'mdi mdi-undo';
        taTools.redo.iconclass = 'mdi mdi-redo';
	taTools.clear.iconclass = 'mdi mdi-eraser';
        taTools.justifyLeft.iconclass = 'mdi mdi-format-align-left';
        taTools.justifyRight.iconclass = 'mdi mdi-format-align-right';
        taTools.justifyCenter.iconclass = 'mdi mdi-format-align-center';
        taTools.justifyFull.iconclass = 'mdi mdi-format-align-justify';
	taTools.insertImage.iconclass = 'mdi mdi-file-image-box';
	taTools.insertLink.iconclass = 'mdi mdi-link-variant';
	taTools.insertVideo.iconclass = 'mdi mdi-youtube-play';
        return taTools;
    }]);

    $provide.decorator('taTranslations', function($delegate) {
	$delegate.bold.tooltip = 'Negrito';
	$delegate.italic.tooltip = 'Itálico';
	$delegate.underline.tooltip = 'Sublinhado';
	$delegate.undo.tooltip = 'Desfazer';
	$delegate.redo.tooltip = 'Refazer';
	$delegate.clear.tooltip = 'Limpar formatação';
	$delegate.justifyLeft.tooltip = 'Alinhar à esquerda';
	$delegate.justifyRight.tooltip = 'Alinhar à direita';
	$delegate.justifyCenter.tooltip = 'Centralizado';
	$delegate.justifyFull.tooltip = 'Justificado';
	$delegate.insertImage.tooltip = 'Inserir imagem';
	$delegate.insertLink.tooltip = 'Inserir link';
	$delegate.insertVideo.tooltip = 'Inserir vídeo';
	return $delegate;
    });
});
